import React from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalSidebarMenu from "../default/header/globalSidebarMenu";


const CardMenu = () => {
    const location = useLocation();
    const isActive = (path) => {
        return location.pathname === path || (location.pathname.startsWith(path) && path !== '/') ? 'active-menu' : '';
      };
    return (
        <div className="card-menu-wrapper">
           <div className="sticky-area has-top-level-menu">
                <div className="top-level-menu">
                    <GlobalSidebarMenu sidebarTitle=" "/>
                </div>
                <ul>
                    <li>
                        <Link className={isActive('/card/update')} to="/card/update">Content</Link>
                    </li>
                    <li>
                        <Link className={isActive('/card/theme')} to="/card/theme">Theme</Link>
                    </li>
                    <li>
                        <Link className={isActive('/widgets')} to="/widgets">Widgets Store</Link>
                    </li>
                    <li>
                        <Link className={isActive('/card/settings')} to="/card/settings">Settings</Link>
                    </li>
                </ul>
           </div>
        </div>
    );
}

export default CardMenu;
